import React, { useEffect, useRef } from "react";
import styled, { keyframes } from "styled-components";
import yodd from "../Assets/newimg.jpg";
import mob from "../Assets/newmobile.jpg";
import Services from "./Services";
import Products from "./Products";
import Clients from "./Clients";
import Footer from "./Footer";
import { Box, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import TeamSection from "./team";
import HeroSection from "./HeroSection";

const HeroContainer = styled(Box)({
  position: 'relative',
  minHeight: '100vh',
  overflow: 'hidden',
});

const Home = ({ homeRef, servicesRef, productsRef, clientsRef, setVacanciesCount, heroWrapperRef, teamRef, footerRef }) => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const scrollTo = location.state.scrollTo;
      if (scrollTo === "Services" && servicesRef.current) {
        servicesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (scrollTo === "Products" && productsRef.current) {
        productsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (scrollTo === "Clients" && clientsRef.current) {
        clientsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (scrollTo === "Our team" && teamRef.current) {
        teamRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state, servicesRef, productsRef, clientsRef, teamRef]);

  return (
    <>
      <MainContainer ref={homeRef}>
        <HeroSection onExploreProducts={() => {
          if (productsRef?.current) {
            productsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }} />
        <Services ref={servicesRef} />
        <Products ref={productsRef} />
        <TeamSection ref={teamRef} />
        <Clients ref={clientsRef} />
      </MainContainer>
      <Footer
        teamRef={teamRef}
        ref={footerRef}
        homeRef={homeRef}
        servicesRef={servicesRef}
        productsRef={productsRef}
        clientsRef={clientsRef}
      />
    </>
  );
};

const comeUp = keyframes`
  0% {
    transform: translateY(5px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const MainContainer = styled.div`
  background-color: #f8f9fa;
  margin-top: -74px;
  min-height: 100vh;

  @media (max-width: 768px) {
    margin-top: -56px;
  }

  @media (max-width: 480px) {
    margin-top: -48px;
  }

  @media (max-width: 320px) {
    margin-top: -40px;
  }
`;

const HeroWrapper = styled.div`
  position: relative;
  // background-image: url(${yodd});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh; // <-- change from height to min-height
  width: 100%;

  @media (max-width: 768px) {
    // background-image: url(${mob});
    min-height: 90vh;
  }

  @media (max-width: 480px) {
    min-height: 50vh;
  }

  @media (max-width: 320px) {
    min-height: 45vh;
  }
`;

const MainContainerImg = styled.div`
  padding: 170px 100px;
  padding: 0px !important;
  position: relative;
  height: 100%;
  background: transparent;
  display: flex;
  align-items: start;
  justify-content: start;

  @media (max-width: 1024px) {
    padding: 0 80px;
  }

  @media (max-width: 768px) {
    padding: 0 20px;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  @media (max-width: 480px) {
    padding: 0 8px;
    margin-right: 0;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  @media (max-width: 320px) {
    padding: 0 5px;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: left;
  color: white;
  max-width: 800px;
  padding: 0 20px;
  margin-left: 20px;

  @media (max-width: 768px) {

    margin-left: 0;
    text-align: center;
    max-width: 100%;
    padding: 0 10px;
    color: #000; /* Change text color to black for better contrast on mobile */
  }

  @media (max-width: 480px) {
    padding: 0 8px;
  }

  @media (max-width: 320px) {
    padding: 0 5px;
  }
`;

const Subtitle = styled.h4`
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: #000;

  @media (max-width: 768px) {
    font-size: 12px;
    letter-spacing: 1.5px;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
  margin-top: 2rem;
    font-size: 10px;
    letter-spacing: 1.2px;
    margin-bottom: 6px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
    letter-spacing: 1px;
    margin-bottom: 5px;
  }
`;

const MainTitle = styled.h1`

  font-size: 1.9rem;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 30px;
  color:rgb(255, 255, 255);

  @media (max-width: 1024px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 15px;
     line-height: 1.5;
      
  }

  @media (max-width: 320px) {
    font-size: 1rem;
    margin-bottom: 10px;
  }
`;

export default Home;